/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chatratelimited2Inputs */

const en_chatratelimited2 = /** @type {(inputs: Chatratelimited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The AI is rate-limited right now. Wait a few seconds and try again.`)
};

const pt_chatratelimited2 = /** @type {(inputs: Chatratelimited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A IA está com limite de pedidos agora mesmo. Espera alguns segundos e tenta novamente.`)
};

/**
* | output |
* | --- |
* | "The AI is rate-limited right now. Wait a few seconds and try again." |
*
* @param {Chatratelimited2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const chatratelimited2 = /** @type {((inputs?: Chatratelimited2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chatratelimited2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chatratelimited2(inputs)
	return pt_chatratelimited2(inputs)
});
export { chatratelimited2 as "chatRateLimited" }